import { StaffPermission } from '@/core/services/staff'

export type { Staff, StaffPermission } from '@/core/services/staff'

export const STAFF_PERMISSION_OPTIONS: {
  value: StaffPermission
  label: string
}[] = [
  { value: 'CHECKIN', label: 'Check-in' },
  { value: 'CHECKOUT', label: 'Check-out' },
]
